import { render, staticRenderFns } from "./ModalResumenBiasMail.vue?vue&type=template&id=e8f36f84&scoped=true&"
import script from "./ModalResumenBiasMail.vue?vue&type=script&lang=js&"
export * from "./ModalResumenBiasMail.vue?vue&type=script&lang=js&"
import style0 from "./ModalResumenBiasMail.vue?vue&type=style&index=0&id=e8f36f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f36f84",
  null
  
)

export default component.exports